import React from "react";
import Footer from "../component/footer";
import Intro from "../component/Intro";

function NOTFOUND({ setmymode, mode }) {
  const textinline2 = {
    headh1: "The",
    spano: "page",
    subh1: "is NOT FOUND",
    paragraph1:
      "the page your are looking to is not found please try agian or contact support team for errors",
  };
  return (
    <div>
      <Intro mode={mode} setmymode={setmymode} textinline={textinline2} />
      <Footer />
    </div>
  );
}

export default NOTFOUND;
